import React, { FC } from 'react'
import dynamic from 'next/dynamic'
import { useTranslation } from 'react-i18next'

const VehicleDetails = dynamic(() => import('../components/VehicleDetails'))

interface Props {
  title: string
  vehicle: any
}

const VehicleDetailsContainer: FC<Props> = ({ title, vehicle }) => {
  const { t } = useTranslation()

  const engineContent = [
    {
      name: t('vehicleDetailsContainer:engine.fuel'),
      value: vehicle.engine.fuel,
    },
    {
      name: t('vehicleDetailsContainer:engine.displacement'),
      value: vehicle.engine.displacement,
    },
    {
      name: t('vehicleDetailsContainer:engine.power'),
      value: vehicle.engine.power,
    },
    {
      name: t('vehicleDetailsContainer:engine.driveType'),
      value: vehicle.engine.driveType,
    },
    {
      name: t('vehicleDetailsContainer:engine.transmission'),
      value: vehicle.engine.gear,
    },
  ]
  const dimensionsContent = [
    {
      name: t('vehicleDetailsContainer:dimensions.sizes'),
      value: vehicle.dimensions.sizes,
    },
    {
      name: t('vehicleDetailsContainer:dimensions.trunk'),
      value: vehicle.dimensions.trunk,
    },
    {
      name: t('vehicleDetailsContainer:dimensions.seats'),
      value: vehicle.dimensions.seats,
    },
    {
      name: t('vehicleDetailsContainer:dimensions.doors'),
      value: vehicle.dimensions.doors,
    },
  ]
  const consumptionContent = [
    {
      name: t('vehicleDetailsContainer:consumption.fuel'),
      value: vehicle.consumption.fuel,
    },
    {
      name: t('vehicleDetailsContainer:consumption.emissions'),
      value: vehicle.consumption.emissions,
    },
  ]

  return (
    <VehicleDetails
      title={title}
      engineTitle={t('vehicleDetailsContainer:engineTitle')}
      engine={engineContent}
      dimensionsTitle={t('vehicleDetailsContainer:dimensionsTitle')}
      dimensions={dimensionsContent}
      consumptionTitle={t('vehicleDetailsContainer:consumptionTitle')}
      consumption={consumptionContent}
    />
  )
}

export default VehicleDetailsContainer
